import { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Space } from '@/components';
import { MainLayout } from '@/layout';
import { makeSelectBanks } from '@/model/invoice/selectors';
import { InvoiceUIState } from '@/model/invoice/types';
import { BanksView } from '@/pages/invoice/components';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    overflow: 'auto',
    flexGrow: 1,
    marginBottom: theme.spacing(3),
  },
}));

const selectBanks = makeSelectBanks();

export const BanksPage: React.FC = () => {
  const classes = useStyles();
  const banks = useSelector(selectBanks);
  return (
    <MainLayout
      minHeight={300}
      height={570}
      buttons={{
        back: `${InvoiceUIState.DETAILS}`,
      }}
      header={{
        title: <FormattedMessage id="invoice.pages.details.title" />,
      }}
      content={{
        prefix: (
          <Space direction="vertical" size={3} className={classes.container}>
            {banks && <BanksView value={banks} />}
          </Space>
        ),
      }}
    />
  );
};

export default BanksPage;
